import { Link } from "react-router-dom";

export default function AboutSection() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="w-full lg:w-1/2">
            <img
              src="https://readdy.ai/api/search-image?query=Minimalist%20fashion%20studio%20scene%20with%20floating%20product%20displays%20on%20cream%20shelves%20white%20sneakers%20beige%20sweater%20leather%20bag%20and%20gold%20accessories%20soft%20natural%20daylight%20through%20large%20window%20scandinavian%20interior%20design%20editorial%20photography%20warm%20neutral%20tones%20elegant%20composition&width=800&height=1000&seq=gtbuy-about-image&orientation=portrait"
              alt="GTBuy Spreadsheet shopping intelligence"
              title="GTBuy Spreadsheet shopping platform"
              className="w-full h-[350px] md:h-[480px] object-cover object-top rounded-3xl"
            />
          </div>

          <div className="w-full lg:w-1/2">
            <span className="inline-block bg-accent-100 text-accent-700 text-xs font-medium px-3 py-1.5 rounded-full mb-4">
              SEO Intelligence System
            </span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 leading-tight mb-5">
              Spreadsheet
              <br />
              Intelligence Network
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                The <strong>GTBuy spreadsheet system</strong> is a powerful shopping intelligence 
                platform designed to help online shoppers make informed purchasing decisions. By 
                aggregating product data, prices, and availability across multiple categories and 
                platforms, the GTBuy sheet serves as your personal shopping assistant.
              </p>
              <p>
                Whether you are comparing sneaker prices, hunting for the best hoodie deals, or 
                tracking limited-edition accessories, the GTBuy spreadsheet provides real-time 
                data-driven insights. Our smart comparison engine ensures you never overpay and 
                always find exactly what you are looking for.
              </p>
              <p>
                Built with the modern shopper in mind, the GTBuy sheet combines the analytical 
                power of a spreadsheet with the visual appeal of a curated product catalog. 
                From <strong>fashion and accessories</strong> to <strong>lifestyle products and beyond</strong>, 
                the GTBuy intelligence network covers it all.
              </p>
            </div>
            <div className="mt-6">
              <Link
                to="/article/gtbuy-spreadsheet-guide"
                className="inline-flex items-center gap-2 bg-secondary-100 hover:bg-secondary-200 text-secondary-800 px-6 py-3 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer"
              >
                Read SEO Guides
                <i className="ri-arrow-right-up-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}